























































































import { Campaign, Campaignthresholds } from '@/data/models/campaign.model';
import { Page } from '@/data/models/page.model';
import { Search } from '@/data/models/search.model';
import { CrudService } from '@/data/services/crud.service';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CampagnaTabella extends Vue {
	@Prop() campagna!: Campaign;
	@Prop() editable!: boolean;

	@Inject('CrudService') campagnaCrudService!: CrudService<Campaignthresholds>;

	campaignthresholds: Campaignthresholds[] = [];

	constructor() {
		super();
	}

	created() {
		this.loadThreshold();
	}

	loadThreshold() {
		const search = new Search('campaignthresholds');
		search.addSimpleFilter('campaignid', this.campagna.id);

		this.campagnaCrudService.searchEntities(Campaignthresholds, 'campaignthresholds', search, new Page(100)).then((results: Campaignthresholds[]) => {
			if (results.length) {
				this.campaignthresholds = results;
			} else {
				this.addThreshold();
			}
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});

	}

	addThreshold() {
		const item = new Campaignthresholds();
		item.campaignid = this.campagna.id;
		this.campaignthresholds.push(item);
	}

	saveThreshold(index: number) {
		this.campagnaCrudService.createEntity(Campaignthresholds, 'campaignthresholds', this.campaignthresholds[index]).then(result => {
			this.campaignthresholds[index] = result;
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}
}
